export default __webpack_public_path__ + "static/media/facebook.93ba6da0.svg";